// @ts-nocheck
import { AttributeService } from './attributeService';
import {
  useMutationEngine,
  useNewQueryEngine,
} from '../../../../queries/useDataEngine';
import { EMPTY_OBJECT } from '../../../../const/CommonConst';

const ATTRIBUTES = 'attributes';

export const ATTRIBUTES_QUERY_KEYS = {
  ALL: [ATTRIBUTES],
  attributeList: {
    ROOT: [ATTRIBUTES, 'attributeList'],
    key: (params = {}) => [ATTRIBUTES, 'attributeList', params],
  },
  details: {
    ROOT: [ATTRIBUTES, 'details'],
    key: (params = {}) => [ATTRIBUTES, 'details', params],
  },
  systemGenerated: {
    ROOT: [ATTRIBUTES, 'systemGenerated'],
    key: (params = {}) => [ATTRIBUTES, 'systemGenerated', params],
  },
  htmlAttributeDownload: {
    ROOT: [ATTRIBUTES, 'htmlAttributeDownload'],
    key: (params = {}) => [ATTRIBUTES, 'htmlAttributeDownload', params],
  },
};

export const useAttributeListQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    ATTRIBUTES_QUERY_KEYS.attributeList.key,
    AttributeService.getAttributeList,
    params,
    options
  );
};

export const useSingleAttributeQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    ATTRIBUTES_QUERY_KEYS.details.key,
    AttributeService.getSingleAttributeDetails,
    params,
    options
  );
};

export const useSystemGeneratedAttributesQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    ATTRIBUTES_QUERY_KEYS.systemGenerated.key,
    AttributeService.getSystemGeneratedAttribute,
    params,
    options
  );
};

export const useCreateAttributeMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(AttributeService.createAttribute, {
    ...options,
    invalidateQueries: [ATTRIBUTES_QUERY_KEYS.attributeList.ROOT],
  });
};

export const useUpdateAttributeMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(AttributeService.updateAttribute, {
    ...options,
    invalidateQueries: [
      ATTRIBUTES_QUERY_KEYS.attributeList.ROOT,
      ATTRIBUTES_QUERY_KEYS.details.ROOT,
    ],
  });
};

export const useDeleteAttributeMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(AttributeService.deleteAttribute, {
    ...options,
    invalidateQueries: [ATTRIBUTES_QUERY_KEYS.attributeList.ROOT],
  });
};

export const useUploadHtmlAttributeTemplateMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(
    AttributeService.uploadHtmlAttributeTemplate,
    options
  );
};

export const useHtmlAttributeDownloadQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    ATTRIBUTES_QUERY_KEYS.htmlAttributeDownload.key,
    AttributeService.downloadHtmlAttribute,
    params,
    options
  );
};
